export default "__VITE_ASSET__D48Ag9OT__"